import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from "../select/Select";
import { AlignedCenterIcon, AlignedLeftIcon, AlignedRightIcon, ChevronDownIcon, ChevronUpIcon, } from "../icons";
import { useState } from "react";
import classNames from "classnames";
export const textAlignSupportedTypes = ["paragraph", "bulletList"];
export const options = [
    {
        value: "left",
        label: "Left aligned",
        iconName: "AlignedLeft",
    },
    {
        value: "center",
        label: "Center aligned",
        iconName: "AlignedCenter",
    },
    {
        value: "right",
        label: "Right aligned",
        iconName: "AlignedRight",
    },
];
export const TextAlignDropdown = ({ editor }) => {
    const [isOpen, setIsOpen] = useState(false);
    const getSelectedOption = () => {
        let selectedOption = null;
        if (editor) {
            const anchorPos = editor.view.state.selection.$anchor.pos;
            editor.state.doc.nodesBetween(anchorPos, anchorPos, ({ type, attrs }) => {
                if (textAlignSupportedTypes.includes(type.name) && attrs.textAlign) {
                    selectedOption = options.find((option) => option.value === attrs.textAlign);
                }
            });
        }
        return selectedOption || options[0];
    };
    const selectedOption = getSelectedOption();
    return (_jsx(Select, { label: "", options: options, className: "!border-none !outline-none", menuClassName: "!w-[180px]", value: selectedOption, selectionType: "single", onChange: (option) => {
            if (option === null || option === void 0 ? void 0 : option.value) {
                editor === null || editor === void 0 ? void 0 : editor.commands.setTextAlign(option.value);
                // focus doesn't work without a timeout here - maybe the select is stealing focus?
                setTimeout(() => editor === null || editor === void 0 ? void 0 : editor.commands.focus(), 0);
            }
        }, onOpenChange: (isOpen) => setIsOpen(isOpen), customTrigger: _jsxs("button", { className: classNames("!rounded-none pr-1 hover:!bg-general-gray-quaternary p-1 cursor-pointer outline-none flex gap-[4px] self-stretch items-center", isOpen &&
                "!bg-general-gray-tertiary hover:!bg-general-gray-tertiary"), type: "button", tabIndex: 0, children: [selectedOption.value === "left" && _jsx(AlignedLeftIcon, {}), selectedOption.value === "center" && _jsx(AlignedCenterIcon, {}), selectedOption.value === "right" && _jsx(AlignedRightIcon, {}), _jsx("span", { className: "w-1 h-1 inline-flex mb-[4px]", children: isOpen ? _jsx(ChevronUpIcon, {}) : _jsx(ChevronDownIcon, {}) })] }) }));
};
//# sourceMappingURL=TextAlignDropdown.js.map